export default "__VITE_ASSET__12687e25__"